import { mapRawWorkItemToWorkItem } from "@buzzeasy/shared-frontend-utilities";
import { RawAgentState, RawWorkItem } from "@buzzeasy/shared-frontend-utilities/agentHubEvents";
import { AgentState } from "../../models/agent";

export function mapToInternalAgentState(external: RawAgentState): AgentState {
  const rawWorkItems: RawWorkItem[] = Object.values(external.workItems ?? {});

  return {
    stateSince: new Date(external.agentProperties.stateSince),
    status: external.agentProperties.state,
    breakName: external.agentProperties.breakName,
    breakBusinessUnitId: external.agentProperties.breakBusinessUnitId,
    timedBreakExpiresAt: external.agentProperties.timedBreakExpiresAt ? new Date(external.agentProperties.timedBreakExpiresAt) : null,
    allowAgentsToSelectBusinessUnits: external.agentProperties.allowAgentsToSelectBusinessUnits,
    disableCustomerCreation: external.agentProperties.disableCustomerCreation,
    disableCustomerEdit: external.agentProperties.disableCustomerEdit,
    workItems: mapRawWorkItemToWorkItem(rawWorkItems),
  };
}
